import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const uploadEvaluations = async ({ periodId, file }) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await client.post(
    `/current-organization/course-assignment/periods/${periodId}/evaluations`,
    formData
  )
  return data
}

export const useUploadEvaluations = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: uploadEvaluations,
    hookName: 'useUploadEvaluations',
    errorMessage: 'Error uploading course assignment evaluations',
    shouldReportError: (error) => error?.response?.status !== 400,
    onSuccess: (_data, { periodId }) => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentEvaluations', periodId] })
    }
  })
}
